import {useEffect, useState} from 'react';
import { Skeleton} from 'antd';
import {CheckCircleFilled, } from '@ant-design/icons';
import './RecordIncident.css';
import {useTranslation} from "react-i18next";
import {useParams} from "react-router-dom";
import { getIncidentConfirmGuidance, getIncidentReference } from '../../api/im';
import PanelFrame from '../../components/panels/PanelFrame';
import OurHTMLFormattedText from "../../components/data/OurHTMLFormattedText";




const SubmitSuccessPage = () => {

    const { t } = useTranslation();
    const {incidentId} = useParams();

    const [incidentReference, setIncidentReference] = useState(null);

    const [loading, setLoading] = useState(true);

    const [confirmGuidance, setConfirmGuidance] = useState(null);

    useEffect(() => {
        getIncidentReference(incidentId, setLoading)
            .then(res => {
                setIncidentReference(res);
                setLoading(false);
            })
            .catch(ignoreErr => {
                setLoading(false);
                setIncidentReference('');
                console.log(ignoreErr);
            });
        getIncidentConfirmGuidance(incidentId)
            .then(res => {
                setConfirmGuidance(res);
            })
            .catch(ignoreErr => {
                setConfirmGuidance('');
                console.log(ignoreErr);
            });
    }, [incidentId]);


    // RENDER
    return (
        <PanelFrame title={null}>
            <Skeleton loading={loading}>
                <div className='success-info'>
                    <CheckCircleFilled className='submit-success' />
                    <div className='incident-submitted'>{t('title.incident_submitted')}</div>
                    <div className='incident-reference-header'>{t('field.incident_reference_is')}</div>
                    <div className='incident-reference'>{incidentReference}</div>                
                </div>
                <OurHTMLFormattedText htmlFormattedText={confirmGuidance} />
            </Skeleton>
        </PanelFrame>
    );
}

export default SubmitSuccessPage;
